"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpersonatedUserContext = void 0;
var react_1 = require("react");
exports.ImpersonatedUserContext = (0, react_1.createContext)({
    name: undefined,
    setState: function () { return undefined; },
});
